<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 518" fill="none" >
    <path d="M35 0V416.5V518" stroke="white" stroke-width="3"/>
    <path d="M35 418C17.9415 418 5.55385 432.385 2 440.289C11.7477 455.464 24.8462 459.577 35 461V418Z" stroke="white" stroke-width="2.4" stroke-linejoin="round"/>
    <path d="M35 418C52.0585 418 64.9462 432.096 68.5 440C58.7523 455.175 45.1538 459.577 35 461V418Z" stroke="white" stroke-width="2.4" stroke-linejoin="round"/>
    <path d="M45 439H56M56 439L52.5 435M56 439L52.5 443.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M25 439H14M14 439L17.5 435M14 439L17.5 443.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'KIconHandle'
}
</script>
